export default {
    meta: {
        title: '完善机会点',
        url: '/standardstore/chancepointlist',
        urlName: '标准版拓店-机会点',
    }
};
